export default {
    init() {

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js